import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const FoodPlotInstallationPage = lazy(() => import('../pages/food-plot-installation-michigan/page'));
const ForestryMulchingPage = lazy(() => import('../pages/forestry-mulching-michigan/page'));
const LandClearingPage = lazy(() => import('../pages/land-clearing-michigan/page'));
const TreePlantingPage = lazy(() => import('../pages/tree-planting-michigan/page'));
const LawnInstallationPage = lazy(() => import('../pages/lawn-installation-michigan/page'));
const DeerHabitatImprovementPage = lazy(() => import('../pages/deer-habitat-improvement-michigan/page'));
const HuntingPropertyManagementPage = lazy(() => import('../pages/hunting-property-management-michigan/page'));
const PropertyImprovementServicesPage = lazy(() => import('../pages/property-improvement-services-michigan/page'));
const StormDamageCleanupPage = lazy(() => import('../pages/storm-damage-cleanup-michigan/page'));
const HuntingBlindInstallationPage = lazy(() => import('../pages/hunting-blind-installation-michigan/page'));
const ATVTrailClearingPage = lazy(() => import('../pages/atv-trail-clearing-michigan/page'));
const LivingstonCountyPage = lazy(() => import('../pages/land-management-livingston-county/page'));
const GeneseeCountyPage = lazy(() => import('../pages/land-management-genesee-county/page'));
const OaklandCountyPage = lazy(() => import('../pages/land-management-oakland-county/page'));
const WashtenawCountyPage = lazy(() => import('../pages/land-management-washtenaw-county/page'));
const FoodPlotLivingstonCountyPage = lazy(() => import('../pages/food-plot-installation-livingston-county/page'));
const FoodPlotGeneseeCountyPage = lazy(() => import('../pages/food-plot-installation-genesee-county/page'));
const FoodPlotOaklandCountyPage = lazy(() => import('../pages/food-plot-installation-oakland-county/page'));
const FoodPlotWashtenawCountyPage = lazy(() => import('../pages/food-plot-installation-washtenaw-county/page'));
const ForestryMulchingLivingstonCountyPage = lazy(() => import('../pages/forestry-mulching-livingston-county/page'));
const ForestryMulchingGeneseeCountyPage = lazy(() => import('../pages/forestry-mulching-genesee-county/page'));
const ForestryMulchingOaklandCountyPage = lazy(() => import('../pages/forestry-mulching-oakland-county/page'));
const ForestryMulchingWashtenawCountyPage = lazy(() => import('../pages/forestry-mulching-washtenaw-county/page'));
const LandClearingLivingstonCountyPage = lazy(() => import('../pages/land-clearing-livingston-county/page'));
const LandClearingGeneseeCountyPage = lazy(() => import('../pages/land-clearing-genesee-county/page'));
const LandClearingOaklandCountyPage = lazy(() => import('../pages/land-clearing-oakland-county/page'));
const LandClearingWashtenawCountyPage = lazy(() => import('../pages/land-clearing-washtenaw-county/page'));
const BestFoodPlotSeedMichiganPage = lazy(() => import('../pages/best-food-plot-seed-for-michigan/page'));
const WhenToPlantFoodPlotsMichiganPage = lazy(() => import('../pages/when-to-plant-food-plots-michigan/page'));
const DeerHabitatSmallPropertiesPage = lazy(() => import('../pages/how-to-improve-deer-habitat-small-properties-michigan/page'));
const HowToClearLandForFoodPlotPage = lazy(() => import('../pages/how-to-clear-land-for-food-plot/page'));
const HowToCreateDeerBeddingAreaPage = lazy(() => import('../pages/how-to-create-deer-bedding-area/page'));
const BestTreesForDeerMichiganPage = lazy(() => import('../pages/best-trees-to-plant-for-deer-in-michigan/page'));
const HowManyAcresForFoodPlotPage = lazy(() => import('../pages/how-many-acres-for-food-plot/page'));
const BestLocationFoodPlotPage = lazy(() => import('../pages/best-location-for-food-plot-on-property/page'));
const ATVTrailClearingLivingstonCountyPage = lazy(() => import('../pages/atv-trail-clearing-livingston-county/page'));
const ATVTrailClearingOaklandCountyPage = lazy(() => import('../pages/atv-trail-clearing-oakland-county/page'));
const DeerHabitatImprovementOaklandCountyPage = lazy(() => import('../pages/deer-habitat-improvement-oakland-county/page'));
const DeerHabitatImprovementWashtenawCountyPage = lazy(() => import('../pages/deer-habitat-improvement-washtenaw-county/page'));
const HuntingBlindInstallationGeneseeCountyPage = lazy(() => import('../pages/hunting-blind-installation-genesee-county/page'));
const HuntingBlindInstallationLivingstonCountyPage = lazy(() => import('../pages/hunting-blind-installation-livingston-county/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/food-plot-installation-michigan',
    element: <FoodPlotInstallationPage />,
  },
  {
    path: '/forestry-mulching-michigan',
    element: <ForestryMulchingPage />,
  },
  {
    path: '/land-clearing-michigan',
    element: <LandClearingPage />,
  },
  {
    path: '/tree-planting-michigan',
    element: <TreePlantingPage />,
  },
  {
    path: '/lawn-installation-michigan',
    element: <LawnInstallationPage />,
  },
  {
    path: '/deer-habitat-improvement-michigan',
    element: <DeerHabitatImprovementPage />,
  },
  {
    path: '/hunting-property-management-michigan',
    element: <HuntingPropertyManagementPage />,
  },
  {
    path: '/property-improvement-services-michigan',
    element: <PropertyImprovementServicesPage />,
  },
  {
    path: '/storm-damage-cleanup-michigan',
    element: <StormDamageCleanupPage />,
  },
  {
    path: '/hunting-blind-installation-michigan',
    element: <HuntingBlindInstallationPage />,
  },
  {
    path: '/atv-trail-clearing-michigan',
    element: <ATVTrailClearingPage />,
  },
  {
    path: '/land-management-livingston-county',
    element: <LivingstonCountyPage />,
  },
  {
    path: '/land-management-genesee-county',
    element: <GeneseeCountyPage />,
  },
  {
    path: '/land-management-oakland-county',
    element: <OaklandCountyPage />,
  },
  {
    path: '/land-management-washtenaw-county',
    element: <WashtenawCountyPage />,
  },
  {
    path: '/food-plot-installation-livingston-county',
    element: <FoodPlotLivingstonCountyPage />,
  },
  {
    path: '/food-plot-installation-genesee-county',
    element: <FoodPlotGeneseeCountyPage />,
  },
  {
    path: '/food-plot-installation-oakland-county',
    element: <FoodPlotOaklandCountyPage />,
  },
  {
    path: '/food-plot-installation-washtenaw-county',
    element: <FoodPlotWashtenawCountyPage />,
  },
  {
    path: '/forestry-mulching-livingston-county',
    element: <ForestryMulchingLivingstonCountyPage />,
  },
  {
    path: '/forestry-mulching-genesee-county',
    element: <ForestryMulchingGeneseeCountyPage />,
  },
  {
    path: '/forestry-mulching-oakland-county',
    element: <ForestryMulchingOaklandCountyPage />,
  },
  {
    path: '/forestry-mulching-washtenaw-county',
    element: <ForestryMulchingWashtenawCountyPage />,
  },
  {
    path: '/land-clearing-livingston-county',
    element: <LandClearingLivingstonCountyPage />,
  },
  {
    path: '/land-clearing-genesee-county',
    element: <LandClearingGeneseeCountyPage />,
  },
  {
    path: '/land-clearing-oakland-county',
    element: <LandClearingOaklandCountyPage />,
  },
  {
    path: '/land-clearing-washtenaw-county',
    element: <LandClearingWashtenawCountyPage />,
  },
  {
    path: '/best-food-plot-seed-for-michigan',
    element: <BestFoodPlotSeedMichiganPage />,
  },
  {
    path: '/when-to-plant-food-plots-michigan',
    element: <WhenToPlantFoodPlotsMichiganPage />,
  },
  {
    path: '/how-to-improve-deer-habitat-small-properties-michigan',
    element: <DeerHabitatSmallPropertiesPage />,
  },
  {
    path: '/how-to-clear-land-for-food-plot',
    element: <HowToClearLandForFoodPlotPage />,
  },
  {
    path: '/how-to-create-deer-bedding-area',
    element: <HowToCreateDeerBeddingAreaPage />,
  },
  {
    path: '/best-trees-to-plant-for-deer-in-michigan',
    element: <BestTreesForDeerMichiganPage />,
  },
  {
    path: '/how-many-acres-for-food-plot',
    element: <HowManyAcresForFoodPlotPage />,
  },
  {
    path: '/best-location-for-food-plot-on-property',
    element: <BestLocationFoodPlotPage />,
  },
  {
    path: '/atv-trail-clearing-livingston-county',
    element: <ATVTrailClearingLivingstonCountyPage />,
  },
  {
    path: '/atv-trail-clearing-oakland-county',
    element: <ATVTrailClearingOaklandCountyPage />,
  },
  {
    path: '/deer-habitat-improvement-oakland-county',
    element: <DeerHabitatImprovementOaklandCountyPage />,
  },
  {
    path: '/deer-habitat-improvement-washtenaw-county',
    element: <DeerHabitatImprovementWashtenawCountyPage />,
  },
  {
    path: '/hunting-blind-installation-genesee-county',
    element: <HuntingBlindInstallationGeneseeCountyPage />,
  },
  {
    path: '/hunting-blind-installation-livingston-county',
    element: <HuntingBlindInstallationLivingstonCountyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;